import { BaseTool } from '../BaseTool';

/**
 * Schedules tool (View tab > Create > Schedules).
 *
 * One-shot: opens the Schedule dialog, which creates real schedules from the
 * project element data and lists the existing ones.
 */
export class ScheduleTool extends BaseTool {
    id = 'VIEW_SCHEDULE';
    name = 'Schedules';
    cursor = 'default';

    onActivate(): void {
        this.context?.appStore.openManageDialog('schedules');
        this.deactivate();
        this.context?.appStore.setActiveTool('select');
    }

    onPointerDown(): void { }
    onPointerMove(): void { }
    onPointerUp(): void { }
}
